import { types } from "@vilocnv/allsetra-core";
import { mapObjectToMarker } from "./map-object-to-marker.mapper";

export function mapObjectsToMarkers(
  objects: types.IObject[]
): types.MarkerType[] {
  return objects
    .map(mapObjectToMarker)
    .filter((marker): marker is types.MarkerType => !!marker);
}
